<template>
    <!-- pointer-events: o combo desabilitado (regime automático) bloqueia cliques nos filhos -->
    <span style="pointer-events: auto;">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click.prevent.stop="abrir">
                    <v-icon>mdi-history</v-icon>
                </v-btn>
            </template>
            <span>Histórico do regime de trabalho</span>
        </v-tooltip>

        <v-dialog v-model="dialog" max-width="760" scrollable>
            <v-card>
                <v-card-title class="d-flex align-center">
                    <v-icon left color="primary">mdi-history</v-icon>
                    <div>
                        <div class="text-h6">Histórico do regime de trabalho</div>
                        <div v-if="teacherName" class="text-caption grey--text">{{ teacherName }}</div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon :disabled="loading" @click="carregar"><v-icon>mdi-refresh</v-icon></v-btn>
                    <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text class="pt-4" style="min-height: 240px;">
                    <div v-if="loading" class="text-center py-8">
                        <v-progress-circular indeterminate color="primary" />
                    </div>

                    <v-alert v-else-if="erro" type="error" dense text>{{ erro }}</v-alert>

                    <v-alert v-else-if="!historico.length" type="info" dense text>
                        Ainda não há alterações registradas para o regime de trabalho deste professor.
                    </v-alert>

                    <v-timeline v-else dense align-top>
                        <v-timeline-item v-for="item in historico" :key="item.id" :color="item.regime_changed ? 'primary' : 'grey lighten-1'" small>
                            <div class="d-flex flex-wrap align-center mb-1">
                                <strong class="mr-3">{{ item.created_at | dateTime }}</strong>
                                <v-chip v-if="item.work_time" x-small outlined class="mr-2">Período {{ item.work_time }}</v-chip>
                                <span class="text-caption grey--text">{{ item.performed_by }}</span>
                            </div>

                            <div class="mb-2">
                                <template v-if="item.regime_changed">
                                    <v-chip small>{{ item.regime_before || 'Sem regime' }}</v-chip>
                                    <v-icon small class="mx-1">mdi-arrow-right</v-icon>
                                    <v-chip small color="primary">{{ item.regime_after || 'Sem regime' }}</v-chip>
                                </template>
                                <template v-else>
                                    <span class="text-body-2">Regime mantido:</span>
                                    <v-chip small class="ml-1">{{ item.regime_after || 'Sem regime' }}</v-chip>
                                </template>
                            </div>

                            <v-simple-table v-if="item.details_after" dense class="regime-history__table">
                                <thead>
                                    <tr>
                                        <th>Carga horária semanal</th>
                                        <th v-if="item.details_before">Antes</th>
                                        <th>Depois</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="linha in linhas" :key="linha.campo">
                                        <td>{{ linha.rotulo }}</td>
                                        <td v-if="item.details_before">{{ formatar(item.details_before[linha.campo], linha.unidade) }}</td>
                                        <td :class="{ 'font-weight-bold': mudou(item, linha.campo) }">{{ formatar(item.details_after[linha.campo], linha.unidade) }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-timeline-item>
                    </v-timeline>
                </v-card-text>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'SysTeacherWorkRegimeHistoryButton',

    props: {
        teacherId: { type: [Number, String], required: true },
        teacherName: { type: String, default: '' },
    },

    data: () => ({
        dialog: false,
        loading: false,
        erro: '',
        historico: [],
        linhas: [
            { campo: 'work_load_total', rotulo: 'CH total (sala de aula + atividades)', unidade: 'h' },
            { campo: 'work_load_class', rotulo: 'CH em sala de aula', unidade: 'h' },
            { campo: 'work_load_activity', rotulo: 'CH em atividades', unidade: 'h' },
            { campo: 'percent_activity', rotulo: '% da CH em atividades', unidade: '%' },
        ],
    }),

    methods: {
        ...mapActions('domainTeacherIndicator', ['ActionWorkRegimeHistory']),

        abrir() {
            this.dialog = true
            this.carregar()
        },

        carregar() {
            this.loading = true
            this.erro = ''
            this.ActionWorkRegimeHistory({ teacher_id: this.teacherId })
                .then(res => { this.historico = res.data || [] })
                .catch(err => {
                    this.historico = []
                    this.erro = (err && err.message) || 'Não foi possível carregar o histórico.'
                })
                .finally(() => { this.loading = false })
        },

        formatar(valor, unidade) {
            if (valor === null || valor === undefined) return '—'
            return Number(valor).toLocaleString('pt-BR', { maximumFractionDigits: 2 }) + (unidade === '%' ? '%' : ' h')
        },

        // Destaca o valor novo quando mudou em relação ao anterior.
        mudou(item, campo) {
            return !!item.details_before && item.details_before[campo] !== item.details_after[campo]
        },
    },
}
</script>

<style scoped>
.regime-history__table { max-width: 520px; }
</style>
